/**
 * The three pieces of the Ziggiz mark, ordered base first. Lifted verbatim
 * from `public/ziggiz-logo.svg` so the rail brand and the loader draw the
 * same geometry instead of two copies that can drift apart.
 */
export const ZIGGIZ_MARK_PATHS = {
  /** Outer chevron — carries the stack. */
  outer:
    'M271.238 170.421L240.731 139.926V200.882L210.224 231.377L179.717 261.873L149.21 292.368L118.703 261.873L88.1955 231.377L57.6885 200.882V139.926L27.1815 170.421L2.34147 195.251C-0.780491 198.372 -0.780491 203.426 2.34147 206.513L27.1815 231.344L57.6885 261.839L88.1955 292.334L118.703 322.829L143.543 347.659C146.665 350.78 151.721 350.78 154.809 347.659L179.649 322.829L210.156 292.334L240.663 261.839L271.17 231.344L296.146 206.377C299.2 203.325 299.2 198.406 296.146 195.353L271.17 170.387L271.238 170.421Z',
  /** Inner chevron — settles into the outer. */
  inner:
    'M88.2966 170.421L118.804 200.882L149.277 231.377L179.784 200.882L210.257 170.421L240.764 139.926L210.257 109.465L179.784 78.9693V139.926L149.277 170.421L118.804 139.926V78.9693L88.2966 109.465L57.7896 139.926L88.2966 170.421Z',
  /** Cap — the tip that closes the mark. */
  cap: 'M179.784 78.9691L154.944 54.1388C151.822 51.018 146.766 51.018 143.678 54.1388L118.838 78.9691L149.345 109.464L179.852 78.9691H179.784Z'
} as const;

/** Tight bounding box of the assembled mark. */
export const ZIGGIZ_MARK_VIEW_BOX = '0 51.8 298.44 298.2';
